import { Environment } from "@shared/interfaces/environment.interface";

export const environment: Environment = {
  production: false,
  env: "QA",
  authClient: "https://betaauthorize.leadadvantagepro.com/",
  api: "https://betaapi.leadadvantagepro.com/api/",
  registrationApi: "https://betaapi.leadadvantagepro.com/",
  insfire: "https://beta.insfiretech.com/",
  PEPro: "https://qa-planexplorer.leadadvantagepro.com/",
  PEAPI: "https://qa-planexplorerapi.leadadvantagepro.com/",
  INSURACTIVE_ACCOUNT_ID: "11645",
  PROTECTOR_PLUS_DENTAL: "https://www.stagingqa.securitylife.com/ppd",
  TO: "lapro_issue@leadadvantage.atlassian.net",
  CC: "internetmarketing@seniormarketsales.com",
  JIRA_ISSUE_EMAIL : 'lapro_issue@leadadvantage.atlassian.net',
  JIRA_FEATURE_EMAIL : 'lapro_feature@leadadvantage.atlassian.net',
  INTERNET_MARKETING_EMAIL : 'internetmarketing@seniormarketsales.com',
  SENDER_EMAIL : 'message@insfiretech.com',
  CMSLink: 'https://qa-cmscheck.seniormarketsales.com/mycarriers',
  launchDarklyClientId: '659ee0105ee610102bc1f3e1',
  SSP_URL: 'https://betaauthorize.leadadvantagepro.com/SelfService/',
};
